import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { API_DOMAIN, API_PORT, CONTEXT_PATH, OFFLINE_API_PORT } from '../env/variables';

export default function useResource(name: string) {
  const token = useSelector((state: any) => state.authenticate.token);
  const resources = useSelector((state: any) => state.resources);
  const [url, setUrl] = useState('');
  const isOffline = useSelector((state: any) => state.resources.offlineMode);

  useEffect(() => {
    if (name) {
      const res = resources[name];
      if (!res) {
        return;
      }
      const { filename, value } = res;
      setUrl(
        `${window.location.protocol}//${API_DOMAIN}:${isOffline? OFFLINE_API_PORT : API_PORT}${CONTEXT_PATH}/api/download?token=${token}&view=false&value=${value}&filename=${filename}`
      );
    }
  }, [token, resources, name]);

  return url;
}
